import { Button, ButtonVariants } from "@inno-ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "@inno-ui/icons";
import cn from "classnames";
import { useTranslation } from "react-i18next";

import { useAppointmentStore } from "../../../../store/appointment/appointment-store";
import { useGeneralStore } from "../../../../store/general/general-store";
import { TimeSlots } from "../../../time-slots/time-slots";
import MobileFooter from "../../mobile-footer/mobile-footer";
import styles from "./time.module.scss";

type TimeProps = {
  isEmbed?: boolean;
};

export function Time({ isEmbed = false }: TimeProps) {
  const { t } = useTranslation();
  const { onNext, onPrev } = useGeneralStore();
  const {
    appointmentData: { timeRange },
  } = useAppointmentStore();

  return (
    <div className={cn(styles.timeContainer, !isEmbed && styles.timeContainerScrollable)}>
      <TimeSlots />
      <MobileFooter
        primaryButton={(
          <Button
            variant={ButtonVariants.Dark}
            label={t("next")}
            width="100%"
            trailingIcon={ChevronRightIcon}
            onClick={onNext}
            disabled={!timeRange.length}
          />
        )}
        secondaryButton={(
          <Button
            variant={ButtonVariants.Light}
            label={t("back")}
            width="100%"
            icon={ChevronLeftIcon}
            onClick={onPrev}
          />
        )}
      />
    </div>
  );
}
